<!-- <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2> -->
<!-- <div *ngIf="!loading" style="display: block"> -->
<!-- </div> -->

<app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
<div *ngIf="!loading" style="display: block">
    <div [chart]="chart"></div>
</div>